import React, { useEffect, useMemo } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { Loader } from '@crossfit/ui'

import DailyClassPlanPage from './DailyClassPlan'
import WeeklyOverviewPage from './WeeklyOverview'
import PDFsPage from './PDFsPage'
import { UnitPreferenceProvider } from './components/UnitPreference'
import SorryCoachPage from './SorryCoach'
import WelcomeFormModal from './WelcomeFormModal'
import {
  SubscriptionPackageType,
  SubscriptionStatus,
} from 'services/programming'
import { useAuth } from 'components/Auth'
import { useMyActiveSubscriptions } from 'hooks/subscriptions'
import { useSelector } from 'react-redux'
import { getMyAffiliates } from 'store/selectors'
import { Role } from 'types'

function ProgrammingPage() {
  const { pathname } = useLocation()
  const { isLoading } = useAuth()
  const { selectedAffiliate: affiliate } = useSelector(getMyAffiliates)
  const isCoach = affiliate?.roles?.includes(Role.Coach) ?? false
  const subscriptions = useMyActiveSubscriptions()
  const needsToCompleteWelcomeForm = useMemo(() => {
    return (
      subscriptions
        ?.filter(
          (s) =>
            s.status === SubscriptionStatus.active &&
            s.package.name === SubscriptionPackageType.ATK,
        )
        .every((ss) => !ss.requirementsMet) && affiliate?.affiliateId != null
    )
  }, [subscriptions, affiliate])

  useEffect(() => {
    scrollTo(0, 0)
  }, [pathname])

  if (isLoading) {
    return <Loader />
  }

  return (
    <UnitPreferenceProvider>
      {needsToCompleteWelcomeForm && <WelcomeFormModal isCoach={isCoach} />}

      <Routes>
        <Route index element={<WeeklyOverviewPage />} />
        <Route path='pdfs' element={<PDFsPage />} />
        <Route path='sorry-coach' element={<SorryCoachPage />} />
        <Route
          path=':track/weekly-overview/:dateSlug'
          element={<WeeklyOverviewPage />}
        />
        <Route
          path=':track/daily-class-plan/:date'
          element={<DailyClassPlanPage />}
        />
        <Route path='*' element={<Navigate to='/' />} />
      </Routes>
    </UnitPreferenceProvider>
  )
}

export default ProgrammingPage
